import { getI18nParams } from "app/filters/i18nFilter";
import {
    getAccountsFields,
    prioritizeIndustryTaxonomyFields,
} from "app/pages/sales-intelligence/pages/manage-integration/configs/accountsFields";
import { getCompanyAsLeadsFields } from "app/pages/sales-intelligence/pages/manage-integration/configs/companyAsLeadsFields";
import { getContactsFields } from "app/pages/sales-intelligence/pages/manage-integration/configs/contactsFields";
import { getLeadsFields } from "app/pages/sales-intelligence/pages/manage-integration/configs/leadsFields";
import type {
    SimilarwebFieldConfig,
    SimilarwebFieldsConfig,
} from "app/pages/sales-intelligence/common-components/export-table/types";

type OptionsCache = {
    locale: string | undefined;
    options: SimilarwebFieldConfig[];
};

const createLocaleAwareOptionsGetter = (getFieldsConfig: () => SimilarwebFieldsConfig) => {
    let cache: OptionsCache | null = null;

    return (): SimilarwebFieldConfig[] => {
        const locale = getI18nParams()?.locale;

        if (cache?.locale === locale) {
            return cache.options;
        }

        const options = prioritizeIndustryTaxonomyFields(Object.values(getFieldsConfig()));
        cache = { locale, options };

        return options;
    };
};

export const getAccountsSimilarwebFieldOptions = createLocaleAwareOptionsGetter(getAccountsFields);
export const getSalesforceContactsSimilarwebFieldOptions = createLocaleAwareOptionsGetter(() =>
    getContactsFields("salesforce"),
);
export const getHubspotContactsSimilarwebFieldOptions = createLocaleAwareOptionsGetter(() =>
    getContactsFields("hubspot"),
);
export const getDynamicsContactsSimilarwebFieldOptions = createLocaleAwareOptionsGetter(() =>
    getContactsFields("dynamics"),
);
export const getLeadsSimilarwebFieldOptions = createLocaleAwareOptionsGetter(getLeadsFields);
export const getCompanyAsLeadsSimilarwebFieldOptions = createLocaleAwareOptionsGetter(getCompanyAsLeadsFields);
